const input = {
    username: 'Username',
    password: 'Password',
    email: 'อีเมล',
    phone_number: 'หมายเลขโทรศัพท์',
    confirm_password: 'ยืนยันรหัสผ่าน',
    search_region_code: 'ค้นหารหัสภูมิภาค',
    backup_code: 'รหัสสำรอง',
    code: 'รหัส',
    label_with_optional: '{{label}} (ไม่บังคับ)',
    email_address: 'ที่อยู่อีเมล',
    email_placeholder: 'ป้อนอีเมลของคุณ',
    enter_email: 'ป้อนอีเมล',
};
export default Object.freeze(input);
